import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoVideoIconBold = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 200,
	viewBox: "0 0 200 200",
	fill: "parent",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M79.0625 63.9583L58.2292 43.125L15 0L0.3125 14.6875L28.75 43.125H21.1458C15.4167 43.125 10.7292 47.8125 10.7292 53.5417V157.708C10.7292 163.438 15.4167 168.125 21.1458 168.125H146.146C148.333 168.125 150.208 167.292 151.875 166.25L185 199.375L199.688 184.688L107.396 92.3958L79.0625 63.9583ZM31.5625 147.292V63.9583H49.5833L132.917 147.292H31.5625ZM135.729 63.9583V91.1458L198.229 153.646V48.3333L156.562 90V53.5417C156.562 47.8125 151.875 43.125 146.146 43.125H87.7083L108.542 63.9583H135.729Z",
		fill: "parent"
	})]
});
const ForwardRef = forwardRef(SvgNoVideoIconBold);
export { ForwardRef as ReactComponent };
